// Apply the platform defaults once per user/browser at session entry.
// Desktop starts in Standard; mobile starts in Classic. Later choices remain available.
export const DEFAULT_THEME = 'liquido';
export const MOBILE_DEFAULT_THEME = 'original';
export const appearanceUserKey = user => user?.id || user?.username || 'guest';

export function applyStandardThemeDefault(user, storage = window.localStorage) {
    if (!user) return;
    const suffix = appearanceUserKey(user);
    const desktopMigrationKey = `appearance_standard_default_v1_${suffix}`;
    const mobileMigrationKey = `appearance_mobile_classic_default_v2_${suffix}`;

    try {
        if (storage.getItem(desktopMigrationKey) !== 'done') {
            storage.setItem(`maquetes_visual_theme_${suffix}`, DEFAULT_THEME);
            storage.setItem(desktopMigrationKey, 'done');
        }

        if (storage.getItem(mobileMigrationKey) !== 'done') {
            let mobile = {};
            try { mobile = JSON.parse(storage.getItem(`mobile_appearance_${suffix}`) || '{}') || {}; } catch (_) {}
            const hasExplicitMobileChoice = mobile.themeExplicit === true
                && ['original', 'liquido'].includes(mobile.theme);
            storage.setItem(`mobile_appearance_${suffix}`, JSON.stringify({
                ...mobile,
                theme: hasExplicitMobileChoice ? mobile.theme : MOBILE_DEFAULT_THEME
            }));
            storage.setItem(mobileMigrationKey, 'done');
        }
    } catch (_) { /* Appearance storage must never prevent signing in. */ }
}
